import { render, staticRenderFns } from "./text-button-image.vue?vue&type=template&id=b699a9e0&scoped=true&"
import script from "./text-button-image.vue?vue&type=script&lang=js&"
export * from "./text-button-image.vue?vue&type=script&lang=js&"
import style0 from "./text-button-image.vue?vue&type=style&index=0&id=b699a9e0&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b699a9e0",
  null
  
)

export default component.exports